import { render, staticRenderFns } from "./ShowTableData.vue?vue&type=template&id=4a64406f&scoped=true"
import script from "./ShowTableData.vue?vue&type=script&lang=js"
export * from "./ShowTableData.vue?vue&type=script&lang=js"
import style0 from "./ShowTableData.vue?vue&type=style&index=0&id=4a64406f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a64406f",
  null
  
)

export default component.exports